import { render, staticRenderFns } from "./calendar-event-type-icon.vue?vue&type=template&id=b33255f0&scoped=true"
import script from "./calendar-event-type-icon.vue?vue&type=script&lang=js"
export * from "./calendar-event-type-icon.vue?vue&type=script&lang=js"
import style0 from "./calendar-event-type-icon.vue?vue&type=style&index=0&id=b33255f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33255f0",
  null
  
)

export default component.exports